import { useFetch } from 'use-http'
import { getAbsoluteServerUrl } from '../config/config'

type CarouselItem = { id: string; description: string; url: string; created_at: Date; updated_at: Date; attachment: { url: string; }[]}

export function useGetCarouselItems() {
  return useFetch<CarouselItem[]>(getAbsoluteServerUrl('/carousel-items'), { responseType: 'json' }, [])
}
